"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderArea = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _presentationUtils = require("@ori/presentation-utils");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _utils = require("../../../utils");
var _EditorialInfo = require("../../EditorialInfo");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const HeaderArea = ({
  breadcrumbs,
  debug,
  header,
  modulePosition,
  className
}) => {
  const theme = (0, _mui.useTheme)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    authorName,
    headline,
    text,
    imageUrl,
    photographerName,
    publishedDate,
    extraLongHeadline,
    backgroundStorybookColor
  } = header;
  if (!headline && !imageUrl) {
    return (0, _utils.renderOrThrowError)({
      debug,
      message: 'EditorialHeader must have specified headline or imageUrl.',
      modulePosition,
      layout: 'EditorialHeader'
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    className: className,
    "data-testid": getTestId(_constants.HEADER_AREA),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.TopBanner, {
      breadcrumbs: breadcrumbs,
      imageUrl: imageUrl,
      title: headline,
      extraLongHeadline: extraLongHeadline,
      backgroundColor: (0, _presentationUtils.mapBackendColorToTheme)({
        theme,
        backendColor: backgroundStorybookColor,
        fallBackColor: theme.palette.common.white
      }),
      textColor: theme.palette.text.primary
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Inner, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_EditorialInfo.EditorialInfo, {
        authorName: authorName,
        photographerName: photographerName,
        publishedDate: publishedDate
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.IntroText, {
        text: text
      })]
    })]
  });
};
exports.HeaderArea = HeaderArea;
